import { defineComponent, h, onMounted, ref, resolveComponent } from 'vue'
import { RouterLink, useRoute } from 'vue-router'
import { computed } from 'vue'
import { useStore } from 'vuex'

import {
  CBadge,
  CSidebarNav,
  CNavItem,
  CNavGroup,
  CNavTitle,
} from '@coreui/vue'
import nav from '@/_nav.js'
import Admin_nav from '@/Admin_nav.js'
import Manager_nav from '@/Manager_nav.js'
import Serwis_nav from '@/Serwis_nav.js'
import Pracownik_nav from '@/Pracownik_nav.js'
import Kierowca_nav from '@/Kierowca_nav.js'

//const store = useStore()

const normalizePath = (path) =>
  decodeURI(path)
    .replace(/#.*$/, '')
    .replace(/(index)?\.(html)$/, '')

const isActiveLink = (route, link) => {
  if (link === undefined) {
    return false
  }

  if (route.hash === link) {
    return true
  }

  const currentPath = normalizePath(route.path)
  const targetPath = normalizePath(link)

  return currentPath === targetPath
}

//let counter = 0;
const isActiveItem = (route, item, visited = new Set()) => {
  // Zabezpieczenie przed zapętleniem na podstawie unikalnego klucza (np. item.to lub item.name)
  const key = item.to || item.name;
  if (visited.has(key)) {
    console.warn('Wykryto cykliczne odwołanie w nawigacji:', key);  
    return false;
  }
  visited.add(key);

  //counter += 1;
  //console.log(`isActiveItem call #${counter}: route.path='${route.path}', item=`, item);
  //console.log('Counters:', counter);
  // Sprawdzenie bezpośredniego dopasowania
  if (isActiveLink(route, item.to)) {
    return true
  }

  // Sprawdzenie zagnieżdżonych elementów
  if (item.items) {
    return item.items.some((child) => isActiveItem(route, child, visited))
  }

  
  return false
}

const AppSidebarNav = defineComponent({
  name: 'AppSidebarNav',
  components: {
    CNavItem,
    CNavGroup,
    CNavTitle,
  },
  setup() {
    const route = useRoute()
    const firstRender = ref(true)
    const store = useStore()

    onMounted(() => {
      firstRender.value = false
    })

    //const roleNavs = computed(() => {
    //  let start = store.state.role;
    //  console.log(start);
    //  return () => import(`@/${start}_nav.js`)  
    //})

    const roleNavs = computed(() => {
      console.log('Odczytuje');
      let start = store.state.role;
      switch (start) {
        case "Admin":
          return Admin_nav;
        case "Manager":
          return Manager_nav;
        case "Serwis":
          return Serwis_nav;
        case "Pracownik":
          return Pracownik_nav;
        case "Kierowca":
          return Kierowca_nav;
      }
      return nav;
    })

    const renderItem = (item) => {
      if (item.items) {
        return h(
          CNavGroup,
          {
            ...(firstRender.value && {
              visible: item.items.some((child) => isActiveItem(route, child)),

            }),
            'data-color': item.color,
          },
          {
            togglerContent: () => [
              h(resolveComponent('CIcon'), {
                customClassName: 'nav-icon',
                name: item.icon,
              }),
              item.name,
            ],
            default: () => item.items.map((child) => renderItem(child)),
          },
        )
      }

      return item.to
        ? h(
          RouterLink,
          {
            to: item.to,
            custom: true,
          },
          {
            default: (props) => {
              // Nadpisanie standardowej logiki Vue Router dla specjalnego przypadku
              let isActive = props.isActive;
              
              // Użyj własnej logiki dla specjalnego przypadku
              if (route.path.includes('/zleceniaWarsztatowe/serwisMobilny/')) {
                const previousPath = store.state.previousPath || '';
                
                if (item.to) {
                  if (previousPath.includes('/zleceniaWarsztatowe') && 
                      !previousPath.includes('/serwisMobilny/') && 
                      item.to.includes('/zleceniaWarsztatowe')) {
                    isActive = true;
                  } else if (previousPath.includes('/zleceniaNaprawMobilne') && 
                      item.to.includes('/zleceniaNaprawMobilne')) {
                    isActive = true;
                  } else {
                    isActive = false;
                  }
                }
              }

              // Użyj własnej logiki dla specjalnego przypadku
              if (route.path.includes('zleceniaWarsztatowe/serwisStacjonarny/')) {
                const previousPath = store.state.previousPath || '';
                
                if (item.to) {
                  if (previousPath.includes('/zleceniaWarsztatowe') && 
                      !previousPath.includes('/serwisStacjonarny/') && 
                      item.to.includes('/zleceniaWarsztatowe')) {
                    isActive = true;
                  } else if (previousPath.includes('/zleceniaNaprawWarsztatowe') && 
                      item.to.includes('/zleceniaNaprawWarsztatowe')) {
                    isActive = true;
                  } else {
                    isActive = false;
                  }
                }
              }
              
              return h(
                resolveComponent(item.component),
                {
                  active: isActive,  // Używamy naszej nadpisanej wartości
                  href: props.href,
                  'data-color': item.color,
                  onClick: () => props.navigate(),
                },
                {
                  default: () => [
                    item.icon &&
                    h(resolveComponent('CIcon'), {
                      customClassName: 'nav-icon',
                      name: item.icon,
                    }),
                    item.name,
                    item.badge &&
                    h(
                      CBadge,
                      {
                        class: 'ms-auto',
                        color: item.badge.color,
                      },
                      {
                        default: () => item.badge.text,
                      },
                    ),
                  ],
                },
              )
            },
          },
        )
        : h(
          resolveComponent(item.component),
          {},
          {
            default: () => item.name,
          },
        )
    }

    return () =>
      h(
        CSidebarNav,
        {},
        {
          //default: () => nav.map((item) => renderItem(item)),
          default: () => roleNavs.value.map((item) => renderItem(item)),
        },
      )
  },
})
export { AppSidebarNav }
